export const APP_LAYOUT_STYLES = {
  LAYOUT:
    'bg-bw02 h-screen pl-[8rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[3.688rem] pb-20 w-[72rem] pc-sm:w-[80.5rem] pc-md-lg:w-[93rem] flex flex-col fadeIn',
  APP_CENTER_LAYOUT:
    'bg-bw02 h-screen pl-[72px] ml-[100px] pc-md:ml-[256px] pt-[3.688rem] pb-20 w-[72rem] pc-sm:w-[80.5rem] pc-md-lg:w-[93rem] flex flex-col fadeIn',
  NAVBAR: {
    BASE_STYLE: 'absolute flex items-center ml-[0]',
    LOGIN_FLOW_STYLE: 'flex items-center mb-6 mt-[18px]',
    CLOSE_BUTTON: 'absolute top-0 right-0 translate-y-[30px] translate-x-[-30px]',
    BACK_BUTTON: {
      LOGIN_FLOW_STYLE:
        'absolute top-0 left-0 mt-[3.75rem] ml-[3.75rem] w-[2.5rem] h-[2.5rem] border box-border border-solid rounded-md border-bw05 flex items-center justify-center',
      BASE_STYLE: '',
    },
    HEADER_STYLE: 'flex items-start mb-6 mt-[18px]',
    TITLE: {
      BASE_STYLE: 'ml-[0.6875rem] text-bw08 font-metricMedium text-xl',
    },
  },
  INVOICE_HUB: {
    MAIN_LAYOUT:
      'bg-bw00 tab-landscape:pl-[88px] pc-sm:pl-[296px] pt-[3.688rem] pb-20 flex flex-col fadeIn tab-landscape:w-[calc(100%-88px)] pc-sm:w-[calc(100%-296px)] height-[100vh]',
    NAVBAR_LAYOUT: 'flex items-center',
  },
  BILLS_HUB: {
    MAIN_LAYOUT:
      'bg-bw00 flex flex-col pl-[72px] pt-[78px] pb-20 fadeIn tab-landscape:w-[calc(100%-88px)] pc-sm:w-[calc(100%-296px)] height-[100vh]',
    NAVBAR_LAYOUT: '',
  },
  BANK_TRANSFER: {
    MAIN_LAYOUT:
      'bg-bw02 flex flex-col tab-landscape:pl-[88px] pc-sm:pl-[296px] pt-[3.688rem] pb-20 fadeIn tab-landscape:w-[calc(100%-88px)] pc-sm:w-[calc(100%-296px)]',
    NAVBAR_LAYOUT: '',
  },
  CHOOSE_PAYMENT_METHOD: {
    MAIN_LAYOUT:
      'bg-bw02 h-[90%] pl-[8rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[3.688rem] pb-20 w-[93rem] pc-sm:w-[78%] pc-md-lg:w-[78%] flex flex-col fadeIn gap-0 fadeIn min-h-[835px]',
    NAVBAR_LAYOUT: 'flex items-start mt-[1rem] mb-[1.875rem]',
    MAIN_LAYOUT_CHOOSE_METHOD:
      'absolute inset-0 z-[50] bg-bw00 h-screen w-screen flex flex-col items-center fadeIn',
  },
};
